export default "__VITE_ASSET__pJX1QMdB__"